import styled from 'styled-components';
import { Button, Link } from 'app/shared/ui';
import { Flex } from '@rebass/grid';

export const ContainerSt = styled.div`
  width: 100%;
  text-align: center;
`;

export const ButtonSt = styled(Button).attrs(() => ({
  variant: 'secondary',
}))`
  padding: 6px;
  font-size: 14px;
  max-width: 268px;
`;

export const PhoneLinkContainerSt = styled(Flex)`
  border: 1px solid rgb(193, 193, 193);
  border-radius: 4px;
  max-width: 268px;
  height: 44px;
  justify-content: center;
  align-items: center;
`;

export const LinkSt = styled(Link).attrs(() => ({
  hoverColor: 'brandSecondary',
  textDecoration: 'unset',
}))`
  color: ${({ theme: { colors } }) => colors.brandSecondary};
  font-size: 14px;
`;
